import { useContext } from 'react';
import { PreloadContext } from '../../../../shared/context/PreloadContext';

export function useIsExactOnlineIntegrationEnabled(): boolean {
	const { isExactOnlineIntegrationEnabled } = useContext(PreloadContext);
	return isExactOnlineIntegrationEnabled;
}
